import axios from 'axios';
// import { useNavigate } from 'react-router';

const Panurl = process.env.REACT_APP_PAN_URL;
const Aadharurl = process.env.REACT_APP_AADHAR_URL;
const url = process.env.REACT_APP_BASE_URL;
const redirect_url = process.env.REACT_APP_REDIRECT_URL;
const redirect_via_tm_url = process.env.REACT_APP_REDIRECT_URL_VIA_TM;
// agent User Details
const AgentAddress = async (
  PostData,
  file,
  setErrOpen,
  // handleFileErr,
  // handleExistErr,
  // handleKycExistErr,
  setSubRes,
  // handleUserExistErr,
  setIsLoading,
  values,
  setOpenRedirect,
  setReDirectUrl
) => {
  setIsLoading(true);
  const formData = new FormData();
  console.log('PostData', PostData);
  console.log('number', sessionStorage.getItem('mobile_number'));

  const currentUrl = window.location.href;
  if (currentUrl.includes('SigninType=ViaTM')) {
    formData.append('file', file, 'image.jpg');
    formData.append(
      'aadhaar_name',
      sessionStorage.getItem('aadhaar_name')
        ? sessionStorage.getItem('aadhaar_name')
        : sessionStorage.getItem('name')
        ? sessionStorage.getItem('name')
        : ''
    );
    formData.append('first_name', PostData.first_name);
    formData.append('home_landmark', '4.9869867987');
    formData.append('last_name', PostData.last_name);
    formData.append('middle_name', PostData.middle_name ? PostData.middle_name : null);
    formData.append(
      'gender',
      sessionStorage.getItem('gender') === 'M'
        ? 'Male'
        : sessionStorage.getItem('gender') === 'F'
        ? 'Female'
        : sessionStorage.getItem('gender') === 'O'
        ? 'Others'
        : null
    );
    formData.append(
      'dob',
      sessionStorage.getItem('dob')
        ? sessionStorage.getItem('dob')
        : sessionStorage.getItem('date_or_year_of_birth')
        ? sessionStorage.getItem('date_or_year_of_birth')
        : ''
    );
    formData.append('father_name', PostData.father_name);
    formData.append(
      'aadhar_number',
      sessionStorage.getItem('uid_number') ? sessionStorage.getItem('uid_number') : sessionStorage.getItem('masked_aadhaar')
    );
    formData.append('pan_number', sessionStorage.getItem('Pan_number'));
    formData.append('mobile_number', sessionStorage.getItem('PhoneNumber'));
    formData.append('pan_name', sessionStorage.getItem('pan_name'));
    formData.append('home_address', values.address);
    formData.append('home_pincode', parseInt(values.pincode));
    formData.append('home_state', values.state);
    formData.append('home_district', values.district);
    // formData.append('home_sub_district', values.sub_district)
    formData.append('refered_by', values.refered_by);
    formData.append('home_village', values.cityorvillage);
    try {
      await axios
        .post(`${url}/finvesta_user_application`, formData, {
          headers: {
            'X-User': sessionStorage.getItem('X-User')
          }
        })
        .then((res) => {
          setIsLoading(false);
          if (res.status === 201) {
            setSubRes(res.data.message);
            const redirect = res.data.data.capture_link;
            sessionStorage.setItem('profile_id', res.data.data.profile_id);
            setReDirectUrl(redirect);
            setOpenRedirect(true);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrOpen(error.response ? error.response.data.error : 'something went wrong');
        });
      // setTimeout(() => {
      //   Navigate('signin');
      // }, 4000);
      // console.log(PostData);
    } catch (error) {
      console.log('error', error);
      setIsLoading(false);
      setErrOpen(error.response ? error.response.data.error : 'something went wrong');
    }
  } else {
    formData.append('file', file, 'image.jpg');
    formData.append(
      'aadhaar_name',
      sessionStorage.getItem('aadhaar_name')
        ? sessionStorage.getItem('aadhaar_name')
        : sessionStorage.getItem('name')
        ? sessionStorage.getItem('name')
        : ''
    );
    formData.append('first_name', PostData.first_name);
    // formData.append('home_landmark', '4.9869867987')
    formData.append('last_name', PostData.last_name);
    formData.append('middle_name', PostData.middle_name ? PostData.middle_name : null);
    formData.append(
      'gender',
      sessionStorage.getItem('gender') === 'M'
        ? 'Male'
        : sessionStorage.getItem('gender') === 'F'
        ? 'Female'
        : sessionStorage.getItem('gender') === 'O'
        ? 'Others'
        : null
    );
    formData.append(
      'dob',
      sessionStorage.getItem('dob')
        ? sessionStorage.getItem('dob')
        : sessionStorage.getItem('date_or_year_of_birth')
        ? sessionStorage.getItem('date_or_year_of_birth')
        : ''
    );
    formData.append('father_name', PostData.father_name);
    formData.append(
      'aadhar_number',
      sessionStorage.getItem('uid_number') ? sessionStorage.getItem('uid_number') : sessionStorage.getItem('masked_aadhaar')
    );
    formData.append('pan_number', sessionStorage.getItem('Pan_number'));
    formData.append('pan_name', sessionStorage.getItem('pan_name'));
    formData.append('mobile_number', sessionStorage.getItem('PhoneNumber'));
    formData.append('email_address', sessionStorage.getItem('email_address'));
    formData.append('home_address', values.address);
    formData.append('home_pincode', values.pincode);
    formData.append('home_state', values.state);
    formData.append('home_district', values.district);
    // formData.append('home_sub_district', values.sub_district)
    formData.append('home_village', values.cityorvillage);
    formData.append('refered_by', values.refered_by);
    try {
      // console.log('change',change);
      // console.log('data at post',PostData);
      await axios
        .post(`${url}/finvesta_user_self_onboarding`, formData)
        .then((res) => {
          console.log('res', res);
          setIsLoading(false);
          if (res.status === 201) {
            setSubRes(res.data.message);
            const redirect = res.data.data.capture_link;
            setReDirectUrl(redirect);
            setOpenRedirect(true);
            sessionStorage.setItem('profile_id', res.data.data.profile_id);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setErrOpen(error.response ? error.response.data.error : 'something went wrong');
        });
    } catch (error) {
      setIsLoading(false);
      setErrOpen(error.response ? error.response.data.error : 'something went wrong');
    }
  }
};

// agent User through Tm Details
export const TmAgentApi = async (PostData, file, Navigate, change) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('first_name', PostData.first_name);
  formData.append('aadhaar_name', sessionStorage.getItem('name'));
  formData.append('last_name', PostData.last_name);
  formData.append('middle_name', PostData.middle_name ? PostData.middle_name : null);
  formData.append(
    'gender',
    sessionStorage.getItem('gender') === 'M'
      ? 'Male'
      : sessionStorage.getItem('gender') === 'F'
      ? 'Female'
      : sessionStorage.getItem('gender') === 'O'
      ? 'Others'
      : null
  );
  formData.append('date_of_birth', sessionStorage.getItem('dob'));
  formData.append('fathers_name', PostData.father_name);
  formData.append(
    'aadhar_number',
    sessionStorage.getItem('uid_number') ? sessionStorage.getItem('uid_number') : sessionStorage.getItem('masked_aadhaar')
  );
  formData.append('pan_number', sessionStorage.getItem('Pan_number'));
  formData.append('mobile_number', sessionStorage.getItem(' mobile_no'));
  formData.append('email_address', sessionStorage.getItem('email_address'));
  formData.append('house_address', PostData.address);
  formData.append('home_pincode', PostData.pin_code);
  formData.append('home_state', PostData.state);
  formData.append('home_district', PostData.district);
  formData.append('home_sub_district', PostData.sub_district);
  formData.append('home_village', PostData.city_or_village);

  try {
    console.log('change', change);
    // console.log('data at post',PostData);
    await axios.post(`${url}/finvesta_user_application`, formData);
    setTimeout(() => {
      Navigate('/AgentSigninTM');
    }, 2000);
    // console.log(PostData);
  } catch (error) {
    console.log('error', error);
    // handleErrOpen()
  }
};

// Aadhar card

// const AadharLocalVerify = async (aadharnum, setIsLoading) => {
//   try {
//     const response = await axios.post(
//       `${Aadharurl}/distributor-on-boarding/aadhar/number/check`,
//       { aadhar_number: aadharnum },
//       {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       }
//     );
//     return response;
//   } catch (error) {
//     console.log(error);
//     // if(error.response.data.error.includes('already exists')){
//     //   console.log("error else");
//     //   handleAadhErrCheck()
//     //   setIsLoading(false);
//     // }
//     setIsLoading(false);
//   }
// };

// export const Aadharapi = async (
//   handleAadhClick,
//   handleAadhErrClick,
//   AadharNo,
//   digiId,
//   // setDigiId,
//   setIsLoading,
//   setData,
//   handleErrAadhaarData,
//   handleAadhErrCheck,
//   setAadhaarMsg
//   // setIframeUrl, handleIframe
// ) => {
//   // const Navigate = useNavigate();

//   setIsLoading(true);
//   try {
//      await AadharLocalVerify(AadharNo, setIsLoading)
//     .then(async(aadhres)=>{
//       if (aadhres.status === 200) {
//         setIsLoading(true)
//         await axios
//           .post(
//             `${Aadharurl}/aadhar-idfy/aadharcard`,
//             { redirect_url: digiId === 'ViaTM' ? redirect_via_tm_url : redirect_url },
//             {
//               headers: {
//                 'Content-Type': 'application/json',
//                 Authorization: 'JWT fefege...',
//                 'Aadhar-no': AadharNo
//               }
//             }
//           )
//           .then((res) => {
//             if (res.status == 200) {
//               const url = res.data.redirect_url;
//               const code = res.data.reference_id;
//               sessionStorage.setItem('reference_id', code);
//               handleAadhClick();
//               sessionStorage.setItem('AadharNo', AadharNo);
//               setTimeout(() => {
//                 // window.location.href = url;
//                 const childWindow = window.open(url, '_blank', 'width=800,height=600');
//                 const checkChildWindowClosed = setInterval(() => {
//                   if (childWindow.closed) {
//                     clearInterval(checkChildWindowClosed);
//                     AadharDataApi(setData, setIsLoading, handleErrAadhaarData);
//                     console.log('Child window closed',);
//                   }
//                 }, 1000);
//               }, 2000);
//             }
//           }
//         ).catch((error)=>{
//           console.log("error",error);
//           handleAadhErrClick();
//           setIsLoading(false);
//         })
//       } else{
//         handleAadhErrCheck()
//         setAadhaarMsg('Aadhaar is already exist')
//         setIsLoading(false);
//       }
//     })
//     .catch((error)=>{
//       console.log("error",error);
//       if(error.response.data.error.includes('already exists')){
//         handleAadhErrCheck()
//         setAadhaarMsg(error.response?error.response.data.error:'Something went wrong')
//         setIsLoading(false);
//       } else{
//         handleAadhErrClick();
//         setIsLoading(false);
//       }
//     })
//   } catch (error) {
//     console.log('error', error);
//     handleAadhErrClick();
//     setAadhaarMsg(error.response.data.error)
//     setIsLoading(false);
//   }
// };

export const CheckCategory = async (setIsLoading, setCheckError, setErrorCheckCat) => {
  setIsLoading(true);
  try {
    await axios
      .post(`${Aadharurl}/finvesta-user/check_payment_category`, {
        user_mobile_number: sessionStorage.getItem('PhoneNumber'),
        gender: sessionStorage.getItem('gender')
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log('fdawsvsdad', error);
        setErrorCheckCat(error.response ? error.response.data.error : 'Unable to login');
        setCheckError(true);
        setIsLoading(false);
        setTimeout(() => {
          sessionStorage.clear();
          window.location.reload();
        }, 5000);
      });
  } catch (error) {
    console.log('fdawsvsdad', error);
    setErrorCheckCat(error.response ? error.response.data.error : 'Unable to login');
    setCheckError(true);
    setIsLoading(false);
  }
};

export const Aadharapi = async (
  handleAadhClick,
  // handleAadhErrClick,
  AadharNo,
  digiId,
  setIsLoading,
  setData,
  handleErrAadhaarData,
  // handleAadhErrCheck,
  setAadhaarMsg,
  setFieldValue
) => {
  setIsLoading(true);

  try {
    // const aadhres = await AadharLocalVerify(AadharNo, setIsLoading, handleAadhErrCheck, setAadhaarMsg);

    // if (aadhres.status === 200) {
    setIsLoading(true);
    const redirectURL = digiId === 'ViaTM' ? redirect_via_tm_url : redirect_url;

    try {
      const res = await axios.post(
        `${Aadharurl}/aadhar-idfy/aadharcard`,
        { redirect_url: redirectURL },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'JWT fefege...',
            'Aadhar-no': AadharNo
          }
        }
      );

      if (res.status === 200) {
        const url = res.data.redirect_url;
        const code = res.data.reference_id;
        sessionStorage.setItem('reference_id', code);
        sessionStorage.setItem('AadharNo', AadharNo);

        handleAadhClick();

        setTimeout(() => {
          const childWindow = window.open(url, '_blank', 'width=800,height=600');
          const checkChildWindowClosed = setInterval(() => {
            if (childWindow.closed) {
              clearInterval(checkChildWindowClosed);
              setIsLoading(false);
              AadharDataApi(setData, setIsLoading, handleErrAadhaarData, setFieldValue, setAadhaarMsg);
            }
          }, 1000);
        }, 2000);
      }
    } catch (error) {
      console.error('Error during redirect API call:', error);
      // handleAadhErrClick();
      setAadhaarMsg(error.response && error.response.data.error ? error.response.data.error : 'Failed to retrieve the redirect URL.');
      setIsLoading(false);
    }
    // } else {
    //   handleAadhErrCheck();
    //   setAadhaarMsg('Aadhaar number already exists.');
    //   setIsLoading(false);
    // }
  } catch (error) {
    // Already handled in AadharLocalVerify, so no need to duplicate error handling here
    // handleAadhErrCheck();
    setAadhaarMsg(error.response && error.response.data.error ? error.response.data.error : 'Failed to retrieve the redirect URL.');
    setIsLoading(false);
  }
};

export const AadharDataApi = async (setData, setIsLoading, handleErrAadhaarData, setFieldValue, setAadhaarMsg) => {
  const token = sessionStorage.getItem('reference_id');
  setIsLoading(true);
  try {
    await axios
      .post(
        `${Aadharurl}/aadhar-idfy/aadhar_data`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'JWT fefege...',
            'Reference-id': token
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          console.log('adhardata', res.data);
          sessionStorage.setItem('AfterAadharVerify', true);
          setIsLoading(false);
          setData(res.data);
          Object.entries(res.data).map(([key, value]) => {
            sessionStorage.setItem(key, value);
          });
          setFieldValue('Aadhar', res.data.uid_number);
          sessionStorage.setItem('masked_aadhaar', res.data.uid_number);
          // window.location.reload();
        }
      })
      .catch((error) => {
        console.log('error', error);
        if (error.response && error.response.data.error === 'No Aadhar data found for the provided reference_id') {
          setIsLoading(false);
          setTimeout(() => {
            AadharDataApi(setData, setIsLoading, handleErrAadhaarData, setFieldValue, setAadhaarMsg);
          }, 10000);
        } else if (error.response && error.response.data.error === 'Aadhar Number not match') {
          setIsLoading(false);
          handleErrAadhaarData();
          sessionStorage.removeItem('reference_id');
          sessionStorage.removeItem('AadharNo');
        } else {
          setIsLoading(false);
          setAadhaarMsg(error.response && error.response.data.error ? error.response.data.error : 'Failed to retrieve the redirect URL.');
          console.log(error);
        }
      });
  } catch (error) {
    if (error.response && error.response.data.error === 'No Aadhar data found for the provided reference_id') {
      setIsLoading(false);
      setTimeout(() => {
        AadharDataApi(setData, setIsLoading, handleErrAadhaarData, setFieldValue, setAadhaarMsg);
      }, 10000);
    } else if (error.response && error.response.data.error === 'Aadhar Number not match') {
      setIsLoading(false);
      handleErrAadhaarData();
    } else {
      setIsLoading(false);
      setAadhaarMsg(error.response && error.response.data.error ? error.response.data.error : 'Failed to retrieve the redirect URL.');

      console.log(error);
    }
  }
};

export const AgentTmAadharapi = async (handleAadhClick, handleAadhErrClick, AadharNo) => {
  try {
    // console.log("enter aadhar",AadharNo);
    await axios
      .post(`${Aadharurl}/aadharverify/aadharcard`, { redirect_url: redirect_url })
      // {headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': 'JWT fefege...'
      // }}

      .then((res) => {
        if (res.status == 200) {
          const url = res.data;
          // console.log("aadhar url", url);
          handleAadhClick();
          sessionStorage.setItem('AadharNo', AadharNo);
          setTimeout(() => {
            window.location.href = url;
          }, 2000);
        }
      });
  } catch (error) {
    // Aadharerror(error.message)
    // if(error.message == "Network Error") {
    handleAadhErrClick();
    // console.log("erraadhar", error.message);
    // }
  }
};

const PanLocalVerify = async (pannum, setIsLoading, setPanErr) => {
  console.log('pan');

  try {
    const response = await axios.post(
      `${Aadharurl}/distributor-on-boarding/pan/number/check`,
      { pan_number: pannum },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    setPanErr(error.response && error.response.data.error ? error.response.data.error : 'Unable to verify your Pan');
    setIsLoading(false);
    return error;
  }
};

const PanLocalAadhVerify = async (pannum, setIsLoading, setPanErr) => {
  console.log('addha');

  try {
    const response = await axios.post(
      `${url}/pan/number/check`,
      { pan_number: pannum },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (error) {
    console.log(error);
    setPanErr(error.response && error.response.data.error ? error.response.data.error : 'Unable to verify your Pan');
    setIsLoading(false);
    return error;
  }
};

// Pan card
export const Panapi = async (
  PanNo,
  Username,
  Dob,
  handlePanClick,
  handlePanErr,
  handlePanDobErr,
  handlePanNameErr,
  handlePanNDErr,
  setPanErr,
  setIsPanLoading,
  data
) => {
  setIsPanLoading(true);
  try {
    const api =
      (await data) === 'aadhar' ? PanLocalAadhVerify(PanNo, setIsPanLoading, setPanErr) : PanLocalVerify(PanNo, setIsPanLoading, setPanErr);
    const response = await api;
    if (response.status === 200) {
      await axios
        .post(
          `${Panurl}/aadhar-idfy/pancard`,
          { pan_number: PanNo, full_name: Username, dob: Dob },
          {
            headers: {
              'Content-Type': 'application/json'
              // 'Authorization': 'JWT fefege...'
            }
          }
        )
        .then((res) => {
          if (res.status === 200) {
            // handlePanClick();
            // sessionStorage.setItem('Pan_number', PanNo);
            setIsPanLoading(false);
            const pan_string = res.data.pan_status;
            console.log('pan_string', pan_string);
            const splitFn = pan_string.split('.');
            console.log(splitFn[0], splitFn[1]);
            if (pan_string === null || pan_string === '') {
              handlePanErr();
              setPanErr(res.data ? res.data.aadhaar_seeding_status : 'Please enter valid PAN number');
              setIsPanLoading(false);
            } else if (res.data.name_match === false && res.data.dob_match === false) {
              handlePanNDErr();
              setIsPanLoading(false);
            } else if (splitFn[0] === 'Existing and Valid' && res.data.dob_match === false) {
              handlePanNameErr();
              setIsPanLoading(false);
            } else if (splitFn[0] === 'Existing and Valid' && res.data.name_match === false) {
              handlePanDobErr();
              setPanErr(res.data.aadhaar_seeding_status);
              setIsPanLoading(false);
            } else if (splitFn[0] === 'Existing and Valid' && res.data.dob_match === true && res.data.name_match === true) {
              handlePanClick();
              sessionStorage.setItem('Pan_number', PanNo);
              sessionStorage.setItem('pan_name', Username);
              sessionStorage.setItem('panVerified', true);
              setIsPanLoading(false);
            }
            // else if (splitFn[0] === 'Existing and Valid' && res.data.name_match === true) {
            //   console.log("15");
            //   handlePanClick();
            //   sessionStorage.setItem('Pan_number', PanNo);
            //   sessionStorage.setItem('panVerified', true);
            //   setIsPanLoading(false);
            // }
            // console.log(res);
          }
        })
        .catch((error) => {
          console.log('errpansdsdf', error.response.data.error);
          setPanErr(error.response ? error.response.data.error : 'Please enter valid PAN number');
          handlePanErr();
          setIsPanLoading(false);
          setPanErr(error.response.data.error);
        });
    } else {
      handlePanErr();
      setIsPanLoading(false);
      setPanErr('Unable to verify your Pan');
    }
  } catch (error) {
    console.log(error);
    handlePanErr();
    setIsPanLoading(false);
    setPanErr(error.response ? error.response.data.error : 'Please enter valid PAN number');
    // console.log("errpan", error.response.data.error);
  }
};

export const PanApiBharath = async (
  PanNo,
  Username,
  Dob,
  handlePanClick,
  handlePanErr,
  handlePanDobErr,
  handlePanNameErr,
  handlePanNDErr,
  setPanErr,
  setIsPanLoading,
  data
) => {
  setIsPanLoading(true);
  try {
    // const api = await PanLocalVerify(PanNo, setIsPanLoading, setPanErr);
    const api = await (data === 'aadhar'
      ? PanLocalAadhVerify(PanNo, setIsPanLoading, setPanErr)
      : PanLocalVerify(PanNo, setIsPanLoading, setPanErr));
    console.log(api);
    if (api.status === 200) {
      await axios
        .post(
          `${Panurl}/aadhar-idfy/pan/verify`,
          { pan_number: PanNo, full_name: Username, date_of_birth: Dob },
          {
            headers: {
              'Content-Type': 'application/json'
              // 'Authorization': 'JWT fefege...'
            }
          }
        )
        .then((res) => {
          if (res.status === 200) {
            // handlePanClick();
            // sessionStorage.setItem('Pan_number', PanNo);
            setIsPanLoading(false);
            const pan_string = res.data.response?.data?.pan_status;
            console.log('pan_string', pan_string);
            // const splitFn = pan_string.split('.');
            // console.log(splitFn[0], splitFn[1]);
            if (pan_string === null || pan_string === '') {
              handlePanErr();
              setPanErr(res.data && res.data.aadhaar_seeding_status ? res.data.aadhaar_seeding_status : 'Please enter valid PAN number');
              setIsPanLoading(false);
            } else if (res.data?.response?.data.name_match === false && res.data?.response?.data.dob_match === false) {
              handlePanNDErr();
              setIsPanLoading(false);
            } else if (pan_string === 'Active' && res.data?.response?.data.dob_match === false) {
              handlePanNameErr();
              setIsPanLoading(false);
            } else if (pan_string === 'Active' && res.data?.response?.data.name_match === false) {
              handlePanDobErr();
              setPanErr(res.data && res.data.aadhaar_seeding_status ? res.data.aadhaar_seeding_status : "Pan name doesn't match");
              setIsPanLoading(false);
            } else if (
              pan_string === 'Active' &&
              res.data?.response?.data.dob_match === true &&
              res.data?.response?.data.name_match === true
            ) {
              handlePanClick();
              sessionStorage.setItem('Pan_number', PanNo);
              sessionStorage.setItem('pan_name', Username);
              sessionStorage.setItem('panVerified', true);
              setIsPanLoading(false);
            }
            // else if (splitFn[0] === 'Existing and Valid' && res.data.name_match === true) {
            //   console.log("15");
            //   handlePanClick();
            //   sessionStorage.setItem('Pan_number', PanNo);
            //   sessionStorage.setItem('panVerified', true);
            //   setIsPanLoading(false);
            // }
            // console.log(res);
          }
        })
        .catch((error) => {
          console.log('errpansdsdf', error.response.data.error);
          setPanErr(error.response ? error.response.data.error : 'Please enter valid PAN number');
          handlePanErr();
          setIsPanLoading(false);
          setPanErr(error.response.data.error);
        });
    } else {
      handlePanErr();
      setIsPanLoading(false);
      setPanErr('Unable to verify your Pan');
    }
  } catch (error) {
    console.log(error);
    handlePanErr();
    setIsPanLoading(false);
    setPanErr(error.response ? error.response.data.error : 'Please enter valid PAN number');
    // console.log("errpan", error.response.data.error);
  }
};

//get api for states and district

export const Getstates = async (setData) => {
  try {
    await axios.get(`${url}/unique_districts`).then((res) => {
      setData(res.data);
      // console.log(res.data);
    });
  } catch (error) {
    console.log(error);
  }
};

export const GetSubdistrict = async (district, setData) => {
  try {
    await axios
      .get(`${url}/sub_districts`, {
        params: {
          district: district
        }
      })
      .then((res) => {
        setData(res.data);
        // console.log(res.data);
      });
  } catch (error) {
    console.log(error);
  }
};

// export const getPincodeData=async(pinCode,setAddressList)=>{
//   try {
//     await axios.get(`${url}/get_pincode_data`,{
//       params:{
//         pincode:pinCode
//       }
//     })
//     .then((res) =>
//       setAddressList(res.data));
//   } catch (error) {
//     console.log(error);
//     console.clear()
//     TokenExpires(error)
//   }
// }

export const fetchPincode = async (pinCode, setAddressList, setErrMes) => {
  try {
    await axios
      .get(
        `${url}/get_pincode_data`,
        {
          params: {
            pincode: pinCode
          }
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setAddressList(res.data);
      });
  } catch (error) {
    console.log(error);
    setErrMes(error.response ? error.response.data.error : 'Something went wrong');
    console.clear();
  }
};

export default AgentAddress;

export const fetchSubDistrict = async (district, setData) => {
  try {
    await axios.get(`${url}/sub_districts?district=${district}`).then((res) => setData(res.data));
  } catch (error) {
    // console.log(error);
  }
};

export const ImageUploadapi = async (setImageUpload) => {
  try {
    await axios
      .get(`${url}/get_profile_pic`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
        },
        responseType: 'arraybuffer'
      })

      .then((res) => {
        console.log('resimage', res);
        const blob = new Blob([res.data], {
          type: res.headers['content-type']
        });
        const imageUrl = URL.createObjectURL(blob);
        setImageUpload(imageUrl);
        // setImageUpload(res.data)
      });
  } catch (error) {
    if (error.response.status === 401) {
      window.location.href = '/self-agentonboarding/signin';
      sessionStorage.clear();
    }
    console.log('error', error.response.status);
  }
};

export const CheckActiveApi = async (setIsLoading, handleAlertOpen) => {
  try {
    setIsLoading(true);
    const res = await axios.get(`${Aadharurl}/aadhar-idfy/get_service_vendor`);
    setIsLoading(false);
    // console.log(res);
    return res; // Return the full response (or res.data if only that is needed)
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    // throw error; // Optional: rethrow to handle in caller
  }
};

export const BharathSendOtp = async (aadhaar, setIsLoading, handleAlertOpen, handleDialogOpen, handleOtpOpen) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${Aadharurl}/aadhar-idfy/aadhaar/send-otp`,
        { aadhaar_no: aadhaar },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        setIsLoading(false);
        handleDialogOpen(res.data);
        handleOtpOpen();
      })
      .catch((error) => {
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
  }
};

export const BharathVerifyOtp = async (data, otp, setIsLoading, handleAlertOpen, setData, setFieldValue, handleDialogClose) => {
  try {
    setIsLoading(true);
    await axios
      .post(
        `${Aadharurl}/aadhar-idfy/aadhaar/verify-otp`,
        {
          request_id: data.request_id,
          result_id: data.result_id,
          otp: otp
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('UserToken')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          sessionStorage.setItem('AadharNo', res.data.aadhaar);
          setIsLoading(false);
          handleDialogClose();
          handleAlertOpen(res.data.message, 'success');
          // AadharDataApi(setData,setIsLoading,handleErrAadhaarData,setFieldValue,setAadhaarMsg)
          sessionStorage.setItem('AfterAadharVerify', true);
          setIsLoading(false);
          setData(res.data);
          Object.entries(res.data).map(([key, value]) => {
            sessionStorage.setItem(key, value);
          });
          Object.entries(res.data.address).map(([key, value]) => {
            sessionStorage.setItem(key, value);
          });
          sessionStorage.setItem('bharatapi', true);
          setFieldValue('Aadhar', res.data.aadhaar);
          sessionStorage.setItem('masked_aadhaar', res.data.aadhaar);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
      });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    console.log('error', error);
  }
};
